<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company?.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company?.uniqid}}">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a routerLink="/hosting">Hosting - Datacenter work visits history</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">{{ currentAssignment?.cabinetName }}</li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div *ngIf="!loading">
        <div class="symbols-title-row">
          <h3 class="mb-0"><b>Cabinet Assignment {{ currentAssignment?.cabinetName }}</b></h3>
        </div>

        <div class="detail-card">
          <div class="detail-card-head"><h4>Information</h4></div>
          <div class="detail-card-body fact-grid">
            <div>
              <div class="fact-row"><span class="k">Cabinet</span><span class="v">{{ currentAssignment?.cabinetName }}</span></div>
              <div class="fact-row"><span class="k">POCs</span><span class="v">{{ currentAssignment?.pocs }}</span></div>
              <div class="fact-row"><span class="k">Combo code</span><span class="v">{{ currentAssignment?.accessCode }}</span></div>
              <div class="fact-row"><span class="k">Contract</span><span class="v">{{ currentAssignment?.contract }}</span></div>
              <div class="fact-row"><span class="k">Contracting account</span><span class="v">{{ currentAssignment?.contractingAccount }}</span></div>
            </div>
            <div>
              <div class="fact-row"><span class="k">Execution date</span><span class="v">{{ currentAssignment?.executionDate }}</span></div>
              <div class="fact-row"><span class="k">Handover date</span><span class="v">{{ currentAssignment?.handoverDate }}</span></div>
              <div class="fact-row"><span class="k">End date of termination right</span><span class="v">{{ currentAssignment?.endDateOfTerminationRight }}</span></div>
              <div class="fact-row"><span class="k">Billing start date</span><span class="v">{{ currentAssignment?.billingStartDate }}</span></div>
              <div class="fact-row"><span class="k">Termination date</span><span class="v">{{ currentAssignment?.terminationDate }}</span></div>
            </div>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-card-head">
            <h4>Work visits</h4>
            <button *roles="['ROLE_CLIENT']" [routerLink]="'/work-visit/new/' + currentAssignment?.cabinetId"
                    [disabled]="!currentAssignment.isValidCOI"
                    id="add_document" type="button" class="btn-new-visit">
              <i class="fa fa-plus-circle"></i> New
            </button>
          </div>
          <div class="detail-card-body">
            <p class="empty-note" *ngIf="workVisitList.length === 0">No work visits found.</p>
            <div class="symbols-market-table" *ngIf="workVisitList.length > 0">
              <p-table [columns]="workVisitTableCols" [customSort]="true"
                       [rowHover]="true" [tableStyle]="{'table-layout':'auto'}" [value]="workVisitList"
                       id="work-visit-list-table">
                <ng-template pTemplate="header">
                  <tr>
                    <th *ngFor="let col of workVisitTableCols"
                        [pSortableColumnDisabled]="!col.sortable" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template let-workVisit pTemplate="body">
                  <tr>
                    <td>
                      <ul class="cab-list">
                        <li *ngFor="let cab of workVisit.selectedCabs">
                          <a *roles="['ROLE_MCKAY']" pTooltip="Go to hosting manager assignment"
                             [href]="hostingManagerUrl + '/cabinet/' + cab.id" target="_blank">{{ cab.name }}</a>
                          <ng-container *roles="['ROLE_CLIENT']">{{ cab.name }}</ng-container>
                        </li>
                      </ul>
                    </td>
                    <td>
                      {{ workVisit.selectedCabs[0].cPop }} / {{ workVisit.selectedCabs[0].tPop }}
                    </td>
                    <td>
                      {{ workVisit.dateFrom | date: 'dd/MM/yyyy' }}
                    </td>
                    <td>
                      {{ workVisit.dateTo | date: 'dd/MM/yyyy' }}
                    </td>
                    <td>
                      <span class="status-pill" [ngClass]="getWorkVisitStatusClass(workVisit.status)">{{ workVisit.status }}</span>
                    </td>
                    <td>
                      <a class="jira-link" [href]="getJiraLink(workVisit.jiraIssue)">{{ workVisit.jiraIssue }}</a>
                    </td>
                    <td>
                      {{ workVisit.requestedDate | date: 'dd/MM/yyyy' }}
                    </td>
                    <td>
                      {{ workVisit.updatedDate | date: 'dd/MM/yyyy' }}
                    </td>
                    <td class="action-width">
                      <div class="row-actions">
                        <ng-container *roles="['ROLE_CLIENT']">
                          <button name="reset_password_link" type="button"
                                  routerLink="/work-visit/edit/{{workVisit.id}}"
                                  class="row-action-link"
                                  *ngIf="currentAssignment.isValidCOI && (workVisit.status === 'Requested' || workVisit.status === 'Rejected' || workVisit.status === 'Draft')">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            <span>Edit</span>
                          </button>
                        </ng-container>
                        <button name="reset_password_link" type="button"
                                class="row-action-link"
                                routerLink="/work-visit/show/{{workVisit.id}}">
                          <i class="fa fa-eye" aria-hidden="true"></i>
                          <span>Show</span>
                        </button>
                        <ng-container *roles="['ROLE_CLIENT']">
                          <button name="cancel_work_visit" type="button"
                                  *ngIf="workVisit.status !== 'Rejected' && workVisit.status !== 'Cancelled'"
                                  (click)="cancelWorkVisit(workVisit)"
                                  class="row-action-link">
                            <i class="fa fa-close" aria-hidden="true"></i>
                            <span>Cancel</span>
                          </button>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                  {{ workVisitList?.length }} results
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-card-head"><h4>Cross Connects</h4></div>
          <div class="detail-card-body">
            <div *ngIf="loadingXcos">
              <p-progressSpinner [style]="{width: '75px', height: '75px'}" animationDuration="1.5s"
                                 strokeWidth="3"></p-progressSpinner>
            </div>
            <div *ngIf="!loadingXcos">
              <p class="empty-note" *ngIf="xcos.length === 0">No Cross Connects found.</p>
              <div class="symbols-market-table" *ngIf="xcos.length > 0">
                <p-table [autoLayout]="true" [columns]="xcoColumns"
                         [value]="xcos" selectionMode="multiple">
                  <ng-template let-columns pTemplate="header">
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                          class="th-{{col.field}}">
                        {{ col.header }}
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template let-loa pTemplate="body">
                    <tr>
                      <ng-container *roles="['ROLE_MCKAY']">
                        <td *ngIf="loa.creationDate !== 'LOA not found'"><a [href]="loaUrl + '/#/loa-edit/' + loa.id"
                                                                            target="_blank">{{ loa.creationDate | date : 'd/MM/y HH:mm' }}</a>
                        </td>
                      </ng-container>
                      <ng-container *roles="['ROLE_CLIENT']">
                        <td *ngIf="loa.creationDate !== 'LOA not found'">{{ loa.creationDate | date : 'd/MM/y HH:mm' }}</td>
                      </ng-container>
                      <td *ngIf="loa.creationDate === 'LOA not found'">LOA not found</td>
                      <td>{{ loa.customerName }}</td>
                      <td>{{ loa.service | titlecase }}</td>
                      <td>{{ loa.mckayEntity }}</td>
                      <td>{{ loa.sender }}</td>
                      <ng-container *roles="['ROLE_MCKAY']">
                        <td *ngIf="loa.crossConnectId !== 'batch LOA'"><a
                          [href]="loaUrl + '/#/xco-edit/' + loa.crossConnectUuid"
                          target="_blank">{{ loa.crossConnectId }}</a></td>
                      </ng-container>
                      <ng-container *roles="['ROLE_CLIENT']">
                        <td *ngIf="loa.crossConnectId !== 'batch LOA'">{{ loa.crossConnectId }}</td>
                      </ng-container>
                      <td *ngIf="loa.crossConnectId === 'batch LOA'"> {{ loa.crossConnectId }}</td>
                      <td>{{ loa.status }}</td>
                      <td>{{ loa.sendDate | date:'d/MM/y HH:mm' }}</td>
                      <td>{{ loa.finalStatus }}</td>
                      <td>{{ loa.finalStatusDate | date : 'd/MM/y HH:mm' }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
